/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CpaInfindCeasByCta from './CpaInfindCeasByCta';
import NullableCeaInfindCeasByCta from './NullableCeaInfindCeasByCta';

/**
 * The FindKnowledgeGraphRelationshipValuesRequest model module.
 * @module model/FindKnowledgeGraphRelationshipValuesRequest
 * @version 2.8.0
 */
class FindKnowledgeGraphRelationshipValuesRequest {
    /**
     * Constructs a new <code>FindKnowledgeGraphRelationshipValuesRequest</code>.
     * @alias module:model/FindKnowledgeGraphRelationshipValuesRequest
     * @param cpa {module:model/CpaInfindCeasByCta} 
     */
    constructor(cpa) { 
        
        FindKnowledgeGraphRelationshipValuesRequest.initialize(this, cpa);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, cpa) { 
        obj['cpa'] = cpa;
    }

    /**
     * Constructs a <code>FindKnowledgeGraphRelationshipValuesRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FindKnowledgeGraphRelationshipValuesRequest} obj Optional instance to populate.
     * @return {module:model/FindKnowledgeGraphRelationshipValuesRequest} The populated <code>FindKnowledgeGraphRelationshipValuesRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FindKnowledgeGraphRelationshipValuesRequest();

            if (data.hasOwnProperty('cpa')) {
                obj['cpa'] = CpaInfindCeasByCta.constructFromObject(data['cpa']);
            }
            if (data.hasOwnProperty('headCeas')) {
                obj['headCeas'] = ApiClient.convertToType(data['headCeas'], [NullableCeaInfindCeasByCta]);
            }
            if (data.hasOwnProperty('tailCeas')) {
                obj['tailCeas'] = ApiClient.convertToType(data['tailCeas'], [NullableCeaInfindCeasByCta]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/CpaInfindCeasByCta} cpa
 */
FindKnowledgeGraphRelationshipValuesRequest.prototype['cpa'] = undefined;

/**
 * @member {Array.<module:model/NullableCeaInfindCeasByCta>} headCeas
 */
FindKnowledgeGraphRelationshipValuesRequest.prototype['headCeas'] = undefined;

/**
 * @member {Array.<module:model/NullableCeaInfindCeasByCta>} tailCeas
 */
FindKnowledgeGraphRelationshipValuesRequest.prototype['tailCeas'] = undefined;






export default FindKnowledgeGraphRelationshipValuesRequest;

